<template>
  <div v-if="$store.getters['authorization/acl'].hasPermission('campaigns_access')"
       class="PlatformCampaignView">
    <ShPageHeader :title="`Kampania: ${activeCampaignDetails.description || '--'}`"
                  description="Poniżej znajdują się szczegółowe informacje dotyczące kampanii."
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: `kampania: ${activeCampaignDetails.description || '--'}`, path: '/campaign-details' }
                  ]" />
    <ShPageLayout>
      <CustomTabs active-tab="campaign_records"
                  :tabs="[
                    { name: 'campaign_records', label: 'Rekordy kampanii', isVisible: true },
                    { name: 'campaign_edit', label: 'Edycja typów kampanii', isVisible: $store.getters['authorization/acl'].hasPermission('allow_campaign_type_edit') },
                    { name: 'campaign_add_record', label: 'Dodawanie rekordów', isVisible: $store.getters['authorization/acl'].hasPermission('allow_add_campaign_records') },
                  ]">
        <template #campaign_records>
          <CampaignRecordsList v-loading="isLoading || !isComponentLoaded"
                               :is-parent-component-loaded="isComponentLoaded"
                               :projects-list="projectsList"
                               :agents-belongs-to-user-list="agentsBelongsToUserList"
                               :campaign-uuid="campaignUuid"
                               @refreshList="refreshList" />
        </template>
        <template #campaign_edit>
          <CampaignEdit :project-uuid="activeCampaignProject.uuid" 
                        :campaign-uuid="campaignUuid"
          />
        </template>
        <template #campaign_add_record>
          <CampaignAddRecord :project-uuid="activeCampaignProject.uuid"
                             :campaign-uuid="campaignUuid" />
        </template>
      </CustomTabs>
    </ShPageLayout>
  </div>
</template>

<script>

import { customValidations } from '@/mixins';
import CustomTabs from '../components/Common/CustomTabs';
import CampaignRecordsList from '../components/Campaigns/CampaignDetails/CampaignRecordsList';
import CampaignAddRecord from '../components/Campaigns/CampaignDetails/CampaignAddRecord';
import CampaignEdit from '../components/Campaigns/CampaignDetails/CampaignEdit';



export default {
  name: 'PlatformCampaign',
  components: {
    CustomTabs,
    CampaignRecordsList,
    CampaignAddRecord,
    CampaignEdit,
  },

  mixins: [customValidations],

  data() {
    return {
      campaignUuid: '',
      isComponentLoaded: false
    };
  },

  computed: {
    activeCampaignDetails() {
      return this.$store.getters['campaigns/activeCampaign'];
    },
    activeCampaignProject() {
      return this.projectsList.filter(project => project.id === this.activeCampaignDetails.project_id)[0]
    },
    campaignList() {
      return this.$store.getters['campaigns/list']?.records
    },
    projectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    userData() {
      return this.$store.getters['authorization/user'];
    },
    statusList() {
      return this.$store.getters['sms/statusList'];
    },
    typeList() {
      return this.$store.getters['sms/typeList'];
    },
    projectsUuids() {
      const projects = this.$store.getters['client/projects/list']?.records;
      const projectsUuids = projects.map(project => project.uuid);
      return projectsUuids;
    },
    agentsBelongsToUserList() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist']?.records;
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/agent/getAgentsList',
      ]);
    },

  },

  methods: {
    refreshList() {
      this.$store.dispatch('campaign/getDetails', this.campaignUuid);
    },
  },

  async created() {
    this.isComponentLoaded = false;
    if (this.mUuidValidation(this.$route.params.campaignUuid)) {
      this.campaignUuid = this.$route.params.campaignUuid;
    } else {
      this.$router.push({ name: 'PlatformProjects' });
    }
    await this.$store.dispatch('client/projects/getList', this.userData.client.client_uuid);
    await this.$store.dispatch('campaigns/getList');
    await this.$store.dispatch('campaign/getDetails', this.campaignUuid);
    const currentActiveCampaign = this.campaignList.filter(campaign => campaign.uuid === this.campaignUuid);
    this.$store.commit('campaigns/FILL_ACTIVE_CAMPAIGN', currentActiveCampaign[0]);
    await this.$store.dispatch('campaign/getAllStatusAndRecordDictionary', {projectUuid: this.activeCampaignProject.uuid, dialoutUuid: this.campaignUuid});
    this.$store.dispatch('user/agent/getAgentsList', this.projectsUuids);
    await this.$store.dispatch('campaign/getSurveyInputTypesList');
    this.isComponentLoaded = true;
  },
};
</script>

<style lang="sass" scoped>
.PlatformCampaignView
</style>